/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.

==========================================================================================*/

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import i18nData from './i18nData'

Vue.use(VueI18n)

if (!localStorage.getItem('locale')) {
  localStorage.setItem('locale', 'fa')
}

export default new VueI18n({
  locale: localStorage.getItem('locale'), // set default locale
  messages: i18nData
})
